import { FeedItemList } from "@api";
import { NewsItem } from "../components/Dashboard/ShortNews/ShortNewsItem";

export const prepareNewsData = (newsFeed?: FeedItemList): NewsItem[] => {
  const feedItems = newsFeed?.feedItems ?? [];

  return feedItems
    .slice(-3)
    .reverse()
    .map(({ link = "", title = "", image = "" }) => ({
      link,
      title,
      imageURL: image,
    }));
};
